// import { constructorSteps } from 'utils';
import { ONBOARDING_DATA_EN, ONBOARDING_DATA_UA } from 'config/onboarding-steps-info';
import { constructorSteps } from '../../utils/constructorSteps';

export const STEPS_DATA_UA = constructorSteps(ONBOARDING_DATA_UA);
export const STEPS_DATA_EN = constructorSteps(ONBOARDING_DATA_EN);